import { EligibleScreen } from '@/components/EligibleScreen';

export default function Eligible() {
  return <EligibleScreen />;
}
